import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'partnerhub-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit {
  @Output() public closePopup = new EventEmitter<boolean>();

  public currentPage = 0;

  @Input() public scrollContainer = null;

  @Input() public disableNavigationWhenInvalid = true;

  @Output() public index = new EventEmitter<number>();

  @Input() public initialPage = 0;

  @Output() public invalidNavigation = new EventEmitter<number>();

  @Input() public pages: { icon: string; label?: string }[];

  @Output() public submitForm = new EventEmitter<boolean>();

  @Input() public subtitles: { icon?: string; label?: string }[] = [];

  @Input() public valid = true;

  constructor() {}

  public ngOnInit() {
    if (this.pages === undefined) {
      throw new Error('pages is undefined');
    }

    this.currentPage = this.initialPage;
  }

  public onClickBackButton(): void {
    if (this.currentPage !== 0) {
      this.currentPage--;

      this.scrollContainer ? document.getElementById(this.scrollContainer).scroll({top:0}) : window.scrollTo(0, 0);
    }

    this.index.emit(this.currentPage);
  }

  public onClickClose(): void {
    this.closePopup.emit(true);
  }

  public onClickNextButton(): void {
    if (this.valid) {
      if (this.pages.length !== this.currentPage + 1) {
        this.currentPage++;
        this.scrollContainer ? document.getElementById(this.scrollContainer).scroll({top:0}) : window.scrollTo(0, 0);
      }

      this.index.emit(this.currentPage);
    } else {
      this.index.emit(-1);
      this.invalidNavigation.next(this.currentPage);
    }
  }

  public onClickSubmit(): void {
    this.submitForm.emit(true);
  }
}
